import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PremerisImage from './PremerisImage'
import { Button, Tooltip } from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import SummarizeIcon from '@mui/icons-material/Summarize'
import { useStyles } from '../CaseDiagnosisStyles'
import CustomizedMenus from './CustomizedMenus'
import { RootState } from '../../../reducers'
import { getSummaryTreeData, getSlideDiagnosis } from '../../../actions'
import { ViewerError } from './ViewerError'

export default function Viewer({
  isShow,
  setShow,
  handleReportOpen,
  trfBarcode,
  stain,
  slide,
  location,
  isDiagnosed,
  isDontReport,
  isReadOnlyMode,
  handleViewerOpen,
  classifier,
  barcodeError,
}): JSX.Element | null {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const { role, userLogin } = useSelector((state: RootState) => state.userLogin)
  const { caseNumber, procedureCodeId } = useSelector((state: RootState) => state.getCaseData)
  const barcodeData = useSelector((state: RootState) => state.addBarcodeData)
  const getButtonClassName = () =>
    isReadOnlyMode && role !== 'NL_WOMA_ADMIN' ? `${classes.disableBtn} ` : `${classes.diagnoseBtn}`
  const [isFilterApplied, setFilterApplied] = useState(false)
  const [imgFilterValue, setImgFilterValue] = useState({
    brightness: 100,
    contrast: 100,
    sharpness: 0,
    gammaR: 100,
    gammaG: 100,
    gammaB: 100,
    sync: true,
  } as any)

  useEffect(() => {
    const storedValue = localStorage.getItem('stains_data')
    if (storedValue) {
      const currentStainFilter = JSON.parse(storedValue)[stain.toLowerCase()]
      if (stain && currentStainFilter) {
        setImgFilterValue(currentStainFilter)
      } else
        setImgFilterValue({
          brightness: 100,
          contrast: 100,
          sharpness: 0,
          gammaR: 100,
          gammaG: 100,
          gammaB: 100,
          sync: true,
        })
    }
  }, [stain])

  useEffect(() => {
    if (imgFilterValue) {
      setFilterApplied(true)
    }
  }, [imgFilterValue, stain])

  const handleReportClick = () => {
    dispatch(getSummaryTreeData({ trfBarcode: trfBarcode, location: location, procedureCode: procedureCodeId }))
    handleReportOpen({ location: location })
  }

  const handleShow = () => {
    // setShow(true)
  }

  const handleHide = () => {
    // setShow(false)
  }

  const handleClick = async (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
    await dispatch(getSlideDiagnosis({ trfBarcode: trfBarcode }))
  }

  return (
    <>
      <div style={{ float: 'right', marginTop: '-80px', marginRight: '5px', display: 'inline-block' }}>
        {/* Gamma Correction */}
        <fieldset
          style={{
            borderRadius: '5px',
            padding: '5px',
            height: '60px',
            marginTop: '10px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            color: 'rgba(0,0,0,0.6)',
          }}
        >
          <legend style={{ fontSize: '12.5px' }}>Diagnosis</legend>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px', height: '100%', marginBottom: '5px' }}>
            <Tooltip title="Capture slide diagnosis" placement="top-start">
              <Button
                id="demo-customized-button"
                aria-controls={open ? 'demo-customized-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="contained"
                disableElevation
                onClick={handleClick}
                endIcon={<KeyboardArrowDownIcon />}
                style={{ width: '80px', height: '36px', display: 'flex', alignItems: 'center' }}
                className={
                  isDiagnosed ? (isDontReport ? classes.dontReportBtn : classes.diagnoseBtn) : classes.notDiagnosedBtn
                }
              >
                <VisibilityIcon style={{ color: '#fff' }} />
              </Button>
            </Tooltip>
            <Tooltip title="Build report" placement="top-start">
              <Button
                variant="outlined"
                disableElevation
                onClick={handleReportClick}
                className={getButtonClassName()}
                style={{ width: '80px', height: '36px', display: 'flex', alignItems: 'center', marginRight: '5px' }}
              >
                <SummarizeIcon style={{ color: '#fff' }} />
              </Button>
            </Tooltip>
          </div>
        </fieldset>
      </div>
      <CustomizedMenus
        currentSlideBarcode={slide}
        currentStain={stain}
        currentLocation={location}
        isReadOnlyMode={isReadOnlyMode}
        trfBarcode={trfBarcode}
        isDiagnosed={isDiagnosed}
        isDontReport={isDontReport}
        handleViewerOpen={handleViewerOpen}
        setAnchorEl={setAnchorEl}
        anchorEl={anchorEl}
        open={open}
      />
      {barcodeError?.message ? (
        <div style={{ position: 'relative', width: '100%', height: 'calc(100vh - 11em)' }}>
          <ViewerError message={barcodeError.message || 'An error occurred while loading the image'} />
        </div>
      ) : (
        isShow !== undefined &&
        barcodeData &&
        barcodeData.data &&
        isFilterApplied && (
          <PremerisImage
            key={`${slide}-${stain}-${classifier}`} // Force re-render on stain/classifier change
            isShow={isShow}
            setShow={setShow}
            stain={stain}
            currentSlideBarcode={slide}
            trfBarcode={trfBarcode}
            imgFilterValue={imgFilterValue}
            classifier={classifier}
            setImgFilterValue={setImgFilterValue}
            currentLocation={location}
            user={userLogin}
            casenumber={caseNumber}
          />
        )
      )}
    </>
  )
}
